import React, { useEffect, useState } from "react";
import { filter, includes, map } from "ramda";
import { useHistory } from "react-router-dom";
import { useOrganizations } from "../../../user-admin/userServices";

import Skeleton from "@material-ui/lab/Skeleton";

import ListSummaryCard from "../../common/ListSummaryCard";
import { capitalize } from "../../../util/stringFormat";

const pluralizeMediaType = mediaType => {
  switch (mediaType) {
    case "module":
      return "modules";
    case "anthology":
      return "anthologies";
    case "collection":
      return "collections";
    default:
      return mediaType;
  }
};

const OwnersList = ({ historyState = null, media, searchState }) => {
  const history = useHistory();
  const organizations = useOrganizations();
  const [owners, setOwners] = useState([]);

  const mediaType = pluralizeMediaType(media.mediaType);
  const state = historyState ?? {
    label: `Back to ${capitalize(mediaType)}`,
    previousLocation: `/creator/${mediaType}`,
    search: {
      [mediaType]: searchState,
    },
  };

  useEffect(() => {
    if (organizations.isSuccess) {
      const owners = filter(
        org => includes(org.organizationId, media.owners),
        organizations.data,
      );
      setOwners(owners);
    }
  }, [media, organizations.isSuccess, organizations.data]);

  return organizations.isLoading ? (
    <Skeleton />
  ) : (
    <ListSummaryCard
      data={map(
        owner => ({
          id: owner.organizationId,
          name: owner.organizationName,
          handleClick: () =>
            history.push(
              `/manage-organizations/organizations/${owner.organizationId}`,
              state,
            ),
        }),
        owners,
      )}
    />
  );
};

export default OwnersList;
